var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrophyCardBenefitIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.589844,
    width: 40,
    height: 40,
    rx: 12,
    fill: "#FFF8CD"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5914_39319)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 12.5898V16.5898C12 18.6553 13.6037 20.5898 16.1414 20.5898C16.4858 21.9193 17.4907 22.9684 18.7902 23.3833C18.612 24.3204 18.282 25.4942 17.6672 26.5898H16V28.5898H24V26.5898H22.3328C21.718 25.4942 21.388 24.3204 21.2098 23.3833C22.5093 22.9684 23.5142 21.9193 23.8586 20.5898C26.3879 20.5898 28 18.6616 28 16.5898V12.5898H12ZM14 16.5898V14.5898H16V18.5898C14.8975 18.5898 14 17.6929 14 16.5898ZM26 16.5898C26 17.6929 25.1025 18.5898 24 18.5898V14.5898H26V16.5898Z",
    fill: "#FFDE03"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5914_39319"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(12 12.5898)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophyCardBenefitIcon);
export default __webpack_public_path__ + "static/media/trophy-card-benefit-icon.745e0691b8990e13d6b67b35f2eb1c9c.svg";
export { ForwardRef as ReactComponent };